import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./utils/redux/store";
import App from "app/containers/App";
import { handleMemberTokenBeforeInit } from "app/utils/memberTokenHandler";
import "./index.css";

// Handle memberToken before React initialization
handleMemberTokenBeforeInit();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
